// State argument is not application state, only the state this reducer is responsible for
function selectedComs(state = "", action) {
  switch (action.type) {
    case "SET_SELECTED_COMS":
      return action.value;
    default:
      return state;
  }
}

export default selectedComs;